// File: src/pages/TaskDetailTestPage.jsx

import React from 'react';
import TaskDetailModal from '@/components/Maintenance/TaskDetailModal';

const TaskDetailTestPage = () => {
  const dummyTaskId = 14; // Make sure task ID 14 exists in your DB

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white px-4">
      <div className="space-y-6 text-center max-w-xl w-full">
        <h2 className="text-2xl font-bold">🧪 Task Detail Modal Test</h2>
        <TaskDetailModal taskId={dummyTaskId} forceOpen={true} />
      </div>
    </div>
  );
};

export default TaskDetailTestPage;
